/* eslint-disable quote-props */

module.exports = {
  'Account security': 'Account security',
  'Phone was updated': 'Phone was updated',
  'Phone is empty': 'Phone is empty',
  'Link is no longer valid': 'Link is no longer valid',
  'Invalid link': 'Invalid link',
  'Incorrect link': 'Incorrect link',
  'Email was updated': 'Email was updated',
  'GO TO LOGIN PAGE': 'GO TO LOGIN PAGE',
  'PURCHASE': 'PURCHASE',
  'SUBSCRIBE': 'SUBSCRIBE',
  'Dark Mode': 'Dark Mode',
  'Light Mode': 'Light Mode',
  'Synonymous': 'Synonymous',
  'Spintax': 'Spintax',
  'Summarize': 'Summarize',
  'Paraphrase': 'Paraphrase',
  'Videos': 'Videos',
  'Support': 'Support',
  'Payments': 'Payments',
  'Account': 'Account',
  'Admin': 'Admin',
  'Texts': 'Texts',
  'Synonymous Tool': 'Synonymous Tool',
  'Type or paste your text to generate another with synonymous (500 words maximum)': 'Type or paste your text to generate another with synonymous (500 words maximum)',
  'Protect words (press TAB key to insert)': 'Protect words (press TAB key to insert)',
  'Generate text': 'Generate text',
  'Text copied to clipboard!': 'Text copied to clipboard!',
  'Copy text': 'Copy text',
  'Save': 'Save',
  'DOWNLOAD PDF': 'DOWNLOAD PDF',
  'DOWNLOAD TXT': 'DOWNLOAD TXT',
  'DOWNLOAD DOCX': 'DOWNLOAD DOCX',
  'DELETE': 'DELETE',
  'Spintax Tool': 'Spintax Tool',
  'Paraphrase Tool': 'Paraphrase Tool',
  'Summarize Tool': 'Summarize Tool',
  'Type or paste your text to generate spintax': 'Type or paste your text to generate spintax',
  'Generate spintax': 'GENERATE SPINTAX',
  'Generate summary': 'GENERATE SUMMARY',
  'Generate paraphrase': 'REWRITE',
  'Spintaxed Text': 'Spintaxed Text',
  'Enter synonym': 'Enter synonym',
  'List of synonyms': 'List of synonyms',
  'Synonyms used': 'Synonyms used',
  'Synonyms removed': 'Synonyms removed',
  'Your Reescrever subscription will be renewed at:': 'Your Reescrever subscription will be renewed at:',
  'The monthly fee is charged at the beginning of each billing period. Some days may pass before the charge appears in your account.': 'The monthly fee is charged at the beginning of each billing period. Some days may pass before the charge appears in your account.',
  'Your Reescrever subscription will be canceled on:': 'Your Reescrever subscription will be canceled on:',
  'RESTART SUBSCRIPTION': 'RESTART SUBSCRIPTION',
  'UNSUBSCRIBE': 'UNSUBSCRIBE',
  'Invoice': 'Invoice',
  'Period': 'Period',
  'Price': 'Price',
  'Type': 'Type',
  'Description': 'Description',
  'NOTE: We only show up to one year of billing history': 'NOTE: We only show up to one year of billing history',
  'Set as default': 'Set as default',
  'Add new card': 'Add new card',
  'Cancel': 'Cancel',
  'Choose card': 'Choose card',
  'Delete card': 'Delete card',
  'My cards': 'My cards',
  'Before making the payment, we ask that you read and accept the terms of the agreement.': 'Before making the payment, we ask that you read and accept the terms of the agreement.',
  'Select credit card': 'Select credit card',
  'View bank details': 'View bank details',
  'Pay with Paypal': 'Pay with Paypal',
  'REESCREVER AGREEMENT': 'REESCREVER AGREEMENT',
  'I accept the contract': 'I accept the contract',
  'Credit card': 'Credit card',
  'Deposit and transfer': 'Deposit and transfer',
  'Paypal': 'Paypal',
  'Weekly Plan': 'Weekly Plan',
  'Monthly Plan': 'Monthly Plan',
  'Quarterly Plan': 'Quarterly Plan',
  'Semiannual Plan': 'Semiannual Plan',
  'Annual Plan': 'Annual Plan',
  'Unlimited Texts': 'Unlimited Texts',
  'Artificial intelligence': 'Artificial intelligence',
  'Spintax Format': 'Spintax Format',
  'API': 'API',
  'Copyscape': 'Copyscape',
  'CONTRACT': 'CONTRACT',
  'After paying by PayPal, we ask that you wait up to 24 hours to activate your account.': 'After paying by PayPal, we ask that you wait up to 24 hours to activate your account.',
  'I confirm that I have read and accept Reescrever\'s contract': 'I confirm that I have read and accept Reescrever\'s contract',
  'Transfer the value of the selected plan to the account:': 'Transfer the value of the selected plan to the account:',
  'Nu Pagamentos S.A.': 'Nu Pagamentos S.A.',
  'CNPJ: 21.719.922/0001-23': 'CNPJ: 21.719.922/0001-23',
  'GLEIDSON HENRIQUE FRIA 39326490874': 'GLEIDSON HENRIQUE FRIA 39326490874',
  'Agency: 0001': 'Agency: 0001',
  'Checking account: 52137597-4': 'Checking account: 52137597-4',
  'After making the deposit / transfer, send us the receipt.': 'After making the deposit / transfer, send us the receipt.',
  'You must accept the contract!': 'You must accept the contract!',
  'The voucher was sent successfully!': 'The voucher was sent successfully!',
  'We request a 24-hour period to register the payment in your account. Generally, registration occurs in less time. Any questions, we are available at the email suporte@reescrever.app': 'We request a 24-hour period to register the payment in your account. Generally, registration occurs in less time. Any questions, we are available at the email suporte@reescrever.app',
  'Drag and drop voucher here or click to send': 'Drag and drop voucher here or click to send',
  'This file is too large. Please compact it before send.': 'This file is too large. Please compact it before send.',
  'Enter your credential': 'Enter your credential',
  'Email': 'Email',
  'Password': 'Password',
  'Forgot your password?': 'Forgot your password?',
  'Log in': 'Log in',
  'Email is required': 'Email is required',
  'Email invalid': 'Email invalid',
  'Password is required': 'Password is required',
  '6 characters minimum': '6 characters minimum',
  '6 characters maximum': '6 characters maximum',
  'Register by filling in the data below': 'Register by filling in the data below',
  'Full name': 'Full name',
  'REGISTER': 'REGISTER',
  'Name is required': 'Name is required',
  '2 characters minimum': '2 characters minimum',
  'Create a new password': 'Create a new password',
  'Your new password has been generated and sent to your email. Enter your email to regain access to your Reescrever account.': 'Your new password has been generated and sent to your email. Enter your email to regain access to your Reescrever account.',
  'RECOVER ACCOUNT': 'RECOVER ACCOUNT',
  'More videos': 'More videos',
  'Ooops... looks like an error occurred!': 'Ooops... looks like an error occurred!',
  'Ooops... looks like an error occurred! Try again in a few minutes. If does not work, send this text to our support to analyze the reason for the error.': 'Ooops... looks like an error occurred! Try again in a few minutes. If does not work, send this text to our support to analyze the reason for the error.',
  'Error code': 'Error code',
  'GO BACK HOME': 'GO BACK HOME',
  'User data': 'User data',
  'Charging and subscription': 'Charging and subscription',
  'Change card': 'Change card',
  'Change payment method': 'Change payment method',
  'Charge details': 'Charge details',
  'Unsubscribe': 'Unsubscribe',
  'Change phone': 'Change phone',
  'Change email': 'Change email',
  'Change password': 'Change password',
  'Name': 'Name',
  'Please enter your name': 'Please enter your name',
  'Occupation': 'Occupation',
  'Please enter your email': 'Please enter your email',
  'Invalid email': 'Invalid email',
  'Cell phone': 'Cell phone',
  'Search': 'Search',
  'EXCLUIR': '* Verification Required',
  'Current password': 'Current password',
  'Enter your current password': 'Enter your current password',
  'New password': 'New password',
  'Enter a new password': 'Enter a new password',
  'Confirm password': 'Confirm password',
  'Enter your new password': 'Enter your new password',
  'Password doesn\'t match': 'Password doesn\'t match',
  'Your API KEY': 'Your API KEY',
  'Change key': 'Change key',
  'The Reescrever API allows you to integrate Reescrever with your SEO tools for the purpose of automating processes.': 'The Reescrever API allows you to integrate Reescrever with your SEO tools for the purpose of automating processes.',
  'Learn more about API integration': 'Learn more about API integration',
  'UPDATE': 'UPDATE',
  'ADD CARD': 'ADD CARD',
  'Number card': 'Number card',
  'Name (exactly as on card)': 'Name (exactly as on card)',
  'Expiring date (MM/AA)': 'Expiring date (MM/AA)',
  'MM/AA': 'MM/AA',
  'CVC': 'CVC',
  'Valid thru': 'Valid thru',
  'Use card as default': 'Use card as default',
  'Your current Reescrever plan is: Monthly Plan. Subscription expiration and renewal is:': 'Your current Reescrever plan is: Monthly Plan. Subscription expiration and renewal is:',
  'The monthly fee is charged at the expiration of the subscription. When changing the plan, billing and change to the new plan will only occur after the end of the contracted period. Therefore, the new plan will only come into force on': 'The monthly fee is charged at the expiration of the subscription. When changing the plan, billing and change to the new plan will only occur after the end of the contracted period. Therefore, the new plan will only come into force on',
  'CHANGE PLAN': 'CHANGE PLAN',
  'Enter to filter questions': 'Enter to filter questions',
  'Write your doubt below': 'Write your doubt below',
  'Write here your question to the Reescrever team...': 'Write here your question to the Reescrever team...',
  'Category': 'Category',
  'Send question': 'Send question',
  'Ok! Thanks.': 'Ok! Thanks.',
  'Send a question': 'Send a question',
  'API Key was updated': 'API Key was updated',
  'Name is empty': 'Name is empty',
  'User data was updated': 'User data was updated',
  'New email is empty': 'New email is empty',
  'Verification email has been sent': 'Verification email has been sent',
  'You must confirm on both emails to make the change': 'You must confirm on both emails to make the change',
  'You must confirm your email': 'You must confirm your email',
  'Current password is empty': 'Current password is empty',
  'New password is empty': 'New password is empty',
  'Current password must be at least 6 characters': 'Current password must be at least 6 characters',
  'New password must be at least 6 characters': 'New password must be at least 6 characters',
  'User password was updated': 'User password was updated',
  'User not found': 'User not found',
  'Password not match': 'Password not match',
  'Email has been confirmed': 'Email has been confirmed',
  'Email has been updated': 'Email has been updated',
  'E-mail has already been confirmed': 'E-mail has already been confirmed',
  'Current email change confirmed. You now need to confirm the new email.': 'Current email change confirmed. You now need to confirm the new email.',
  'New email change confirmed. You now need to confirm the current email.': 'New email change confirmed. You now need to confirm the current email.',
  'This is the current email. To change you need to choose another email.': 'This is the current email. To change you need to choose another email.',
  'An SMS code will be sent': 'An SMS code will be sent',
  'SMS Code': 'SMS Code',
  'Use {{phoneCode}} to verify your phone on Reescrever': 'Use {{phoneCode}} to verify your phone on Reescrever',
  'Phone is invalid': 'Phone is invalid',
  'Phone number is not mobile': 'Phone number is not mobile',
  'Please enter SMS Code': 'Please enter SMS Code',
  'SMS Code is incorrect': 'SMS Code is incorrect',
  'Phone has been confirmed and updated': 'Phone has been confirmed and updated',
  'SMS code has been sent': 'SMS code has been sent',
  '* Confirm your phone with SMS code sent.': '* Confirm your phone with SMS code sent.',
  'SMS code has been resent': 'SMS code has been resent',
  'Not a phone number': 'Not a phone number',
  'Phone must be different from the current one': 'Phone must be different from the current one',
  'Click to copy the API': 'Click to copy the API',
  'API Key was copied to the clipboard': 'API Key was copied to the clipboard',
  'Please enter credit card number': 'Please enter credit card number',
  'Please enter credit card name': 'Please enter credit card name',
  'Please enter credit card expiration': 'Please enter credit card expiration',
  'Please enter credit card CVV': 'Please enter credit card CVV',
  '12 number minimum': '12 number minimum',
  '13 number minimum': '13 number minimum',
  '14 number minimum': '14 number minimum',
  '15 number minimum': '15 number minimum',
  '16 number minimum': '16 number minimum',
  '17 number minimum': '17 number minimum',
  '18 number minimum': '18 number minimum',
  '19 number minimum': '19 number minimum',
  '20 number minimum': '20 number minimum',
  '3 number minimum': '3 number minimum',
  '4 number minimum': '4 number minimum',
  'Phone is already used by another user': 'Phone is already used by another user',
  'Contract must be accept': 'Contract must be accept',
  'Preferred': 'Preferred',
  'Define as preferred': 'Define as preferred',
  'ADD PAYPAL': 'ADD PAYPAL',
  'Recurring payment': 'Recurring payment',
  'Actions': 'Actions',
  'Delete': 'Delete',
  'Show card data': 'Show card data',
  'cardID is empty': 'cardID is empty',
  'Error changing default payment': 'Error changing default payment',
  'Error removing payment': 'Error removing payment',
  'Expiry date is invalid': 'Please enter credit card expiration',
  'Expiry month should be between 01 and 12': 'Expiry month should be between 01 and 12',
  'Expiry year cannot be in the past': 'Expiry year cannot be in the past',
  'Card expired': 'Card expired',
  'Card is invalid': 'Card is invalid',
  'Already have an account?': 'Already have an account?',
  'Don\'t have an account yet?': 'Don\'t have an account yet?',
  'Sign in': 'Sign in',
  'Sign up': 'Sign up',
  'Add a credit card or paypal': 'Add a credit card or paypal',
  'You don\'t have an added form of payment yet. First add a credit card or link your paypal account for a recurring subscription.': 'You don\'t have an added form of payment yet. First add a credit card or link your paypal account for a recurring subscription.',
  'Transfer receipts': 'Transfer receipts',
  'Delete transfer receipt': 'Delete transfer receipt',
  'The voucher must be deleted only if you are sure that the payment has not occurred and that it will not actually happen.': 'The voucher must be deleted only if you are sure that the payment has not occurred and that it will not actually happen.',
  'Generally, transfers can take up to 3 days to appear. If it has already passed and has not yet appeared, it may be that some of the data is wrong or that the user made an appointment instead of transferring.': 'Generally, transfers can take up to 3 days to appear. If it has already passed and has not yet appeared, it may be that some of the data is wrong or that the user made an appointment instead of transferring.',
  'When deleting the receipt, an email will be sent to the user.': 'When deleting the receipt, an email will be sent to the user.',
  'Are you sure you want to proceed?': 'Are you sure you want to proceed?',
  'Yes': 'Yes',
  'No': 'No',
  'Find users and logs': 'Find users and logs',
  'Delete payment method': 'Delete payment method',
  'When you delete the payment method, it will no longer be used. You can add it again if you wish.': 'When you delete the payment method, it will no longer be used. You can add it again if you wish.',
  'Since this is the preferred payment method, when it is deleted, another random payment method will be set as preferred. If desired, you can define another preferred payment method before or after deletion.': 'Since this is the preferred payment method, when it is deleted, another random payment method will be set as preferred. If desired, you can define another preferred payment method before or after deletion.',
  'As it is the only payment method, the subscription will be canceled and will not be renewed later, thus causing the Reescrever to be interrupted before you finish your job. Your subscription will only be active until the end of the paid period.': 'As it is the only payment method, the subscription will be canceled and will not be renewed later, thus causing the Reescrever to be interrupted before you finish your job. Your subscription will only be active until the end of the paid period.',
  'Regular price': 'Regular price',
  '10% off': '10% off',
  '20% off': '20% off',
  '30% off': '30% off',
  'Account balance': 'Account balance',
  'Add balance': 'Add balance',
  'Bank transfer': 'Bank transfer',
  'You can add balance to your account through Bank Billet and Bank Transfer and use it to sign up for Reescrever, without needing a credit card.': 'You can add balance to your account through Bank Billet and Bank Transfer and use it to sign up for Reescrever, without needing a credit card.',
  'How do you prefer to add balance?': 'How do you prefer to add balance?',
  'Bank billet': 'Bank billet',
  'Transfer': 'Bank transfer',
  'Delete text': 'Delete text',
  'After deleting the text, it will no longer be possible to obtain it again.': 'After deleting the text, it will no longer be possible to obtain it again.',
  'Make sure you have a copy in a safe place before deleting.': 'Make sure you have a copy in a safe place before deleting.',
  'Spinned text was updated': 'Spinned text was updated',
  'Text was updated': 'Text was updated',
  'The spinning process is taking place. At the moment, this process is taking too long, in some cases even more than 5 minutes. So be patient. If an error occurs, you will be informed.': 'The spinning process is taking place. At the moment, this process is taking too long, in some cases even more than 5 minutes. So be patient. If an error occurs, you will be informed.',
  'Your paraphrased text is being generated': 'Your paraphrased text is being generated',
  'Rephrase': 'Rephrase',
  'OriginalSentence': 'Original Sentence',
  'NEW': 'NEW',
  'NEW TEXT': 'NEW TEXT',
  'Are you sure?': 'Are you sure?',
  'Make sure you have saved text before proceeding. It will not be possible to recover it.': 'Make sure you have saved text before proceeding. It will not be possible to recover it.',
  'E-mail already registered': 'E-mail already registered',
  'User no longer exists': 'User no longer exists',
  'E-mail has been updated previously. Nothing has been accomplished now.': 'E-mail has been updated previously. Nothing has been accomplished now.',
  'It is currently possible to paraphrase only in Portuguese': 'It is currently possible to paraphrase only in Portuguese',
  'Validate your email to be able to use Reescrever. A welcome email with a validation button was sent to': 'Validate your email to be able to use Reescrever. A welcome email with a validation button was sent to',
  'Select a phrase before generating a new paraphrase': 'Select a phrase before generating a new paraphrase',
  'Copy': 'Copy',
  'Text was copied to the clipboard': 'Text was copied to the clipboard',
  'The limit is 300 words for the free plan': 'The limit is 300 words for the free plan',
  'The limit is 1000 words for the free plan': 'The limit is 1000 words for the free plan',
  'The limit is 2000 words for paid plans': 'The limit is 2000 words for paid plans',
  'The limit is 5000 words for paid plans': 'The limit is 5000 words for paid plans',
  'An error occurred while copying the text': 'An error occurred while copying the text',
};
